import React, { useEffect, useState } from 'react';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { useNavigate, useParams } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';

import ProcurementRequestItemReturn, {
  ReturnProcurementItemType
} from 'components/procurement-request-item-return';
import { ProcurementItemType } from 'models/procurement.model';
import RequestDetailsWrapper from 'components/base/request-details-wrapper';
import useRoleContext from 'contexts/role.context';
import { InventoryModule, RolePermission } from 'models/permission.model';

const ReturnItems = () => {
  const router = useNavigate();
  const [updatedRequestItems, setUpdatedRequestItems] = useState<ReturnProcurementItemType[]>([]);
  const { activeStore } = useDashboardContext();
  const [loading, setLoading] = useState(false);
  const { ids } = useParams();
  const [procurementItems, setProcurementItems] = useState<ProcurementItemType[]>([]);
  const { can } = useRoleContext();
  const canWriteProcurement = can(InventoryModule.Procurement, RolePermission.Write);

  const getProcurementItems = async () => {
    if (!activeStore) return;
    try {
      setLoading(true);
      const idsArray = ids?.includes(',') ? ids.split(',') : [ids || ''];

      const res: { data: { data: ProcurementItemType[] } } = await apiService.post(
        `procurement/get-items`,
        { version: 'v2', data: { procurement_item_ids: idsArray } }
      );
      if (res) {
        const data = res?.data?.data;
        setProcurementItems(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getProcurementItems();
  }, [ids]);

  const handleItemChange = (itemsForProcurementItem: ReturnProcurementItemType[]) => {
    setUpdatedRequestItems((prev) => {
      const idsToReplace = new Set(itemsForProcurementItem.map((item) => item.id));
      const filtered = prev.filter((item) => !idsToReplace.has(item.id));
      return [...filtered, ...itemsForProcurementItem];
    });
  };

  const handleUpdate = async () => {
    if (!canWriteProcurement) return;
    const data = {
      note: '.',
      items: updatedRequestItems.map((item: ReturnProcurementItemType) => ({
        batch_no: Number(item.batch_no.split(' ')[1]),
        id: item.id,
        quantity_returned: item.quantityReturned
      }))
    };
    try {
      setLoading(true);
      const res = await apiService.put(
        `procurement/${procurementItems[0]?.procurement_request_id}/return`,
        {
          data,
          version: 'v2'
        }
      );
      if (res) {
        toast(<ToastMessage type='success' message=' Items returned successfully' />);
        router(-1);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <RequestDetailsWrapper
      codeId={procurementItems[0]?.code}
      header='Update returned items'
      subHeader='State the quantity received in good condition where necessary'>
      {procurementItems.map((item) => (
        <ProcurementRequestItemReturn key={item.id} item={item} onItemChange={handleItemChange} />
      ))}
      <div>
        <div className='flex gap-6 items-center justify-end mt-6 mx-[28px] ml-auto'>
          <Button variant='link' color='gray' small onClick={() => router(-1)}>
            Back
          </Button>
          {canWriteProcurement && (
            <Button
              variant='block'
              color='primary'
              small
              className='w-[153px] h-[43px]'
              onClick={handleUpdate}
              loading={loading}>
              Update
            </Button>
          )}
        </div>
      </div>
    </RequestDetailsWrapper>
  );
};

export default ReturnItems;
